// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__Mqq8x","wrapper":"Projects_wrapper__c7kUy","header":"Projects_header__P1fCw","container":"Projects_container__-9eVi"};